import React, { useState, useEffect, useRef } from 'react';
//import { LineChart, Line, BarChart, Bar, PieChart, Pie, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, LabelList } from 'recharts';
import { Sun, ChevronDown, Bell, HelpCircle } from 'lucide-react';
//import MonthPicker from './MonthPicker';
import EnergyTabs from './EnergyTabs';
import { useKeycloak } from '@react-keycloak/web';


// Mock data
const mockEnergyData = {
    daily: [
        { hour: '01:00', consumption: 1.2, production: 10, grid: 1.2 },
        { hour: '02:00', consumption: 4.4, production: 9.1, grid: 1.4 },
        { hour: '03:00', consumption: 1.2, production: 5.4, grid: 1.7 },
        { hour: '04:00', consumption: 2.2, production: 1, grid: 1.2 },
        { hour: '05:00', consumption: 1.2, production: 0, grid: 1.7 },
        { hour: '06:00', consumption: 2.2, production: 7.2, grid: 1.9 },
        { hour: '07:00', consumption: 1.2, production: 0, grid: 1.4 },
        { hour: '08:00', consumption: 7.2, production: 4.6, grid: 1.3 },
        { hour: '09:00', consumption: 1.2, production: 3.1, grid: 3.6 },
        { hour: '10:00', consumption: 1.4, production: 2.2, grid: 0.7 },
        { hour: '11:00', consumption: 8.2, production: 9.2, grid: 6.1 },
        { hour: '12:00', consumption: 4.2, production: 1.1, grid: 8.1 },
        { hour: '13:00', consumption: 1.2, production: 0.3, grid: 1.2 },
        { hour: '14:00', consumption: 1.2, production: 0.4, grid: 4.4 },
        { hour: '15:00', consumption: 1.8, production: 2, grid: 7.1 },
        { hour: '16:00', consumption: 1.2, production: 3, grid: 1.8 },
        { hour: '17:00', consumption: 1.2, production: 2.8, grid: 1.2 },
        { hour: '18:00', consumption: 0.8, production: 5, grid: 0.8 },
        { hour: '19:00', consumption: 1.5, production: 7.3, grid: 1.2 },
        { hour: '20:00', consumption: 2.3, production: 3.1, grid: -0.8 },
        { hour: '21:00', consumption: 1.9, production: 4.2, grid: -2.3 },
        { hour: '22:00', consumption: 2.1, production: 3.5, grid: -1.4 },
        { hour: '23:00', consumption: 3.2, production: 8.1, grid: 2.1 },
        { hour: '24:00', consumption: 2.7, production: 0.5, grid: 2.7 }
    ],
    weekly: [
        { day: 'Mon', consumption: 12.5, production: 8.2, grid: 4.3 },
        { day: 'Tue', consumption: 11.8, production: 9.5, grid: 2.3 },
        { day: 'Wed', consumption: 13.2, production: 7.8, grid: 5.4 },
        { day: 'Thu', consumption: 10.5, production: 8.7, grid: 1.8 },
        { day: 'Fri', consumption: 12.7, production: 9.2, grid: 3.5 },
        { day: 'Sat', consumption: 14.2, production: 10.1, grid: 4.1 },
        { day: 'Sun', consumption: 9.8, production: 9.7, grid: 0.1 }
    ],
    sources: [
        { name: 'Community Solar', value: 58 },
        { name: 'Community Wind', value: 12 },
        { name: 'Utility', value: 30 }
    ],
    historicalCommunitySources: [
        { name: 'Solar', value: 58 },
        { name: 'Wind', value: 12 },
        { name: 'Utility', value: 30 }
    ],
    historicalHouseHoldSources: [
        { name: 'Community', value: 58 },
        { name: 'Household', value: 12 },
        { name: 'Utility', value: 30 }
    ],
    historicalNoPvHouseholdSources: [
        { name: 'Community', value: 58 },
        { name: 'Household', value: 12 }
    ],
    bestTimes: [
        { time: '00:00-06:00', rate: 'Low', savings: '30%' },
        { time: '06:00-10:00', rate: 'Medium', savings: '15%' },
        { time: '10:00-16:00', rate: 'Low', savings: '25%' },
        { time: '16:00-20:00', rate: 'High', savings: '0%' },
        { time: '20:00-00:00', rate: 'Medium', savings: '10%' }
    ],
    trading: [
        { neighbor: 'HouseHold1', available: 2.5, price: 0.12 },
        { neighbor: 'HouseHold2', available: 1.7, price: 0.11 },
        { neighbor: 'HouseHold3', available: 5.2, price: 0.10 }
    ]
};

// Custom tooltip to show time of peak demand
export const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
        return (
            <div className="bg-white p-2 border border-gray-200 rounded shadow-md">
                <p className="text-sm">Time of day when peak demand occurred: <strong>{payload[0].payload.time}</strong></p>
            </div>
        );
    }
    return null;
};

// Colors for charts
const COLORS = ['#FFBB28', '#0088FE', '#00C49F', '#FF8042'];
const Dashboard = () => {
    const { keycloak, initialized } = useKeycloak();
    const [showDropdown, setShowDropdown] = useState(false);
    const [view, setView] = useState('household'); // 'household' or 'community'
    const [darkMode, setDarkMode] = useState(false);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    // Add this ref to your component
    const dropdownRef = useRef(null);

    // And add the ref to your dropdown container
    <div className="relative" ref={dropdownRef}>
        {/* Dropdown content */}
    </div>

    // Data for the daily peak demand
    const data = [
        { day: 'Mon', value: 2.17, time: '15h45' },
        { day: 'Tues', value: 3.80, time: '10h45' },
        { day: 'Wed', value: 1.99, time: '09h30' },
        { day: 'Thur', value: 2.23, time: '10h45' },
        { day: 'Fri', value: 4.50, time: '07h45' },
        { day: 'Sat', value: 1.91, time: '13h30' },
        { day: 'Sun', value: 2.48, time: '16h15' }
    ];


    //const [activeTab, setActiveTab] = useState('overview');
    //const [selfSufficiency] = useState(57);
    //const [selfConsumption] = useState(73);

    // State variables needed for dropdowns
    // const [timelineOption, setTimelineOption] = useState('yesterday');
    // const [showTimelineDropdown, setShowTimelineDropdown] = useState(false);
    // const [houseTimelineDropdown, setHouseTimelineDropdown] = useState(false);
    // const [communityTimelineDropdown, setCommunityTimelineDropdown] = useState(false);
    // const [period, setPeriod] = useState('thisMonth');
    //     const [currentRevenue, setCurrentRevenue] = useState(42.80);
    //     const [targetRevenue, setTargetRevenue] = useState(100);
    //     const percentComplete = (currentRevenue / targetRevenue) * 100;
    //     // State for tracking hovered segment and tooltip
    //     const [hoveredSegment, setHoveredSegment] = useState(null);
    //     const [tooltip, setTooltip] = useState({ show: false, text: "", x: 0, y: 0 });

    // Status data for charging stations
    // const stations = [
    //     { id: 1, name: 'EV Charging Station 1', available: false, nextAvailable: '11:30am' },
    //     { id: 2, name: 'EV Charging Station 2', available: true, nextAvailable: '' }
    // ];

    // Data for sustainability timeline
    //const hours = ['09h00', '13h00', '17h00', '21h00', '01h00', '05h00', '09h00'];

    // Segments represent periods (start hour index, end hour index, type)
    // type: 'imported' or 'community'
    // const segments = [
    //     { id: 1, start: 0, end: 1, type: 'imported' },  // 09h00-13h00: imported
    //     { id: 2, start: 1, end: 2, type: 'community' }, // 13h00-17h00: community
    //     { id: 3, start: 2, end: 3, type: 'imported' },  // 17h00-21h00: imported
    //     { id: 4, start: 3, end: 6, type: 'community' }  // 21h00-09h00: community
    // ];

    // Handle mouse enter for segments
    // const handleMouseEnter = (id, type, event) => {
    //     setHoveredSegment(id);
    //     const text = type === 'imported' ? 'Mainly imported electricity' : 'Mainly community energy';

    //     // Get the timeline container element's position
    //     const timelineEl = event.currentTarget.parentElement;
    //     const timelineRect = timelineEl.getBoundingClientRect();

    //     // Calculate position relative to the timeline container
    //     const rect = event.currentTarget.getBoundingClientRect();
    //     const segmentMiddleX = rect.left + (rect.width / 2) - timelineRect.left;

    //     // Position the tooltip above the segment with a fixed distance from the top
    //     setTooltip({
    //         show: true,
    //         text: text,
    //         x: segmentMiddleX,
    //         y: -2 // Negative value to position above the timeline
    //     });
    // };

    // Handle mouse leave for segments
    // const handleMouseLeave = () => {
    //     setHoveredSegment(null);
    //     setTooltip({ ...tooltip, show: false });
    // };

    // const handleMonthChange = (monthIndex, factor) => {
    //     // Generate random revenue between 1 and 999
    //     const randomRevenue = Math.max(1, Math.min(999, Math.floor(Math.random() * 300) + 20));

    //     // Generate random target between the revenue value and 999
    //     // This ensures target is always >= revenue and <= 999
    //     const minTarget = randomRevenue;
    //     const maxTarget = 999;
    //     const randomTarget = Math.floor(Math.random() * (maxTarget - minTarget + 1)) + minTarget;

    //     // Update values with the random numbers
    //     setCurrentRevenue(randomRevenue);
    //     setTargetRevenue(randomTarget);
    // };

    if (!initialized) {
        return <div>Loading...</div>;
    }

    if (!keycloak.authenticated) {
        return <div>Unauthorized – please log in</div>;
    }


    return (
        <div className={`min-h-screen ${darkMode ? 'dark bg-gray-900' : 'bg-gray-100'}`}>

            <div className="container mx-auto p-4">
                {/* Header */}
                <div className="flex justify-between items-center mb-6">
                    <div>
                        <h1 className="text-2xl font-bold dark:text-white">Energy Management Dashboard</h1>
                        <p className="text-sm text-gray-500 dark:text-gray-400">Welcome to your community energy platform</p>
                    </div>
                    <div className="flex items-center space-x-4">
                        <button onClick={() => setDarkMode(!darkMode)} className="p-2 rounded-full bg-gray-200 dark:bg-gray-700">
                            {darkMode ? (
                                <Sun size={18} className="text-yellow-500" />
                            ) : (
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-gray-700">
                                    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
                                </svg>
                            )}
                        </button>
                        <div className="relative">
                            <button className="flex items-center space-x-1 bg-white dark:bg-gray-800 p-2 rounded-lg shadow" onClick={() => setShowDropdown(!showDropdown)}>
                                <span className="text-sm font-medium dark:text-white">{keycloak.tokenParsed?.preferred_username || keycloak.tokenParsed?.name || keycloak.tokenParsed?.email || "User"}</span>
                                <ChevronDown size={16} className="text-gray-500" />
                            </button>
                            {showDropdown && (
                                <div className="absolute right-0 mt-2 w-48 bg-white dark:bg-gray-800 rounded-lg shadow-lg z-10">
                                    <div className="py-1">
                                        <button
                                            onClick={() => keycloak.logout()}
                                            className="block w-full text-left px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700"
                                        >
                                            Sign Out
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {/* Tabs */}
                <div className="bg-white dark:bg-gray-800 rounded-lg shadow overflow-hidden mb-6">
                    <div className="flex border-b border-gray-200 dark:border-gray-700">
                        <EnergyTabs
                            view={view}
                            setView={setView}
                            mockEnergyData={mockEnergyData}
                            COLORS={COLORS}
                            data={data}

                        />
                    </div>
                </div>



                {/* Footer */}
                <div className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow mb-6 flex justify-between items-center">
                    <div className="text-sm text-gray-500 dark:text-gray-400">
                        Last updated: Today at 12:45 PM
                    </div>
                    <div className="flex items-center space-x-4">
                        <button className="flex items-center text-sm text-blue-500">
                            <Bell size={16} className="mr-1" />
                            Notifications
                        </button>
                        <button className="flex items-center text-sm text-blue-500">
                            <HelpCircle size={16} className="mr-1" />
                            Help
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;
